import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const planificadorTareaCustomImporterSelectors = importerSelectors('planificadorTareaCustom.importer');

export default planificadorTareaCustomImporterSelectors;
